import { FormControl } from '@mui/material';
import styled from 'styled-components';

export const RadioToggleFormControl = styled(FormControl)`
  && {
    min-width: fit-content;
  }
`;
